export default "__VITE_ASSET__BOnz26NW__"